export const FLEXIBILITY_STATUSES = {
  unavailable: 'unavailable',
  available: 'available',
  not_enabled: 'not_enabled',
  no_payments_to_reschedule: 'no_payments_to_reschedule',
};

export const FLEXIBILITY_STATUS_LABELS = t => ({
  [FLEXIBILITY_STATUSES.unavailable]: t('dynamic:flexibility_status.unavailable'),
  [FLEXIBILITY_STATUSES.available]: t('dynamic:flexibility_status.available'),
  [FLEXIBILITY_STATUSES.not_enabled]: t('dynamic:flexibility_status.not_enabled'),
  [FLEXIBILITY_STATUSES.no_payments_to_reschedule]: t(
    'dynamic:flexibility_status.no_payments_to_reschedule',
  ),
});
